import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { SuccessMessages, LoginSuccessfully } from "../../../../Constant";
import { SUCCESS_MESSAGES } from "../../../../Data/Bonus Ui/SweetAlert";

const SuccessMessage = () => {
  const displayAlert = () => {
    SweetAlert.fire({ icon: "success", title: "Good job!", text: "You clicked the button!", confirmButtonColor:"#33BFBF" });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={SuccessMessages} span={SUCCESS_MESSAGES} />
        <CardBody className="btn-showcase">
          <Btn color="success" className="sweet-1" type="button" onClick={displayAlert}>
            {LoginSuccessfully}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SuccessMessage;
